<template>
    <div class="home">
        <router-view class="home-router"/>
    </div>
</template>

<script>
  import {mapState} from "vuex";

  export default {
    name: "home",
    computed: {
      ...mapState({
        route: state => state.route
      })
    },
    mounted() {
    },
    data() {
      return {};
    },
    methods: {}
  };
</script>

<style lang="scss">
    $tabActive: #378ede;
    $tabColor: #fff;
    $tabDefult: #999;
    .van-tabbar {
        .van-tabbar-item {
            background-color: $tabColor;

            .van-tabbar-item__text {
                color: $tabDefult;
                font-size: 0.14rem;
            }

            .iconfont {
                font-size: 0.2rem;
                line-height: 0.2rem;
                color: $tabDefult;
            }
        }

        .van-tabbar-item--active {
            // background-color: $tabActive;
            .van-tabbar-item__text {
                color: $tabActive;
            }

            .iconfont {
                color: $tabActive;
            }
        }
    }

    .van-tabbar.van-hairline--top-bottom::after {
        border-bottom: none;
    }
</style>

<style lang="scss" scoped>
    .home {
        > .home-router {
            height: 100%;
            width: 100%;
            padding-bottom: 50px;
            overflow: auto;
            @include box-sizing(border-box);
        }
    }
</style>
